import { IDLE } from "../../global/statusLabels";
import { GET_ADHESION_STATUS_SUCCESS, GET_INVITE_REMINDER_SUCCESS, GET_PROFILO_ARIANNA_SUCCESS, GET_SCREENING_RESULT_SUCCESS, POST_APPOINTMENT_CONFIRM_SUCCESS, RESET_SCREENING_STATE } from "./actionsType";

const initialState = {
    profiloArianna: { value: undefined, status: IDLE },
    screeningResult: { value: undefined, status: IDLE },
    adhesionStatus: { value: undefined, status: IDLE },
    inviteReminder: { value: undefined, status: IDLE },
    appointmentConfirm: { value: undefined, status: IDLE },
}

export const screeningReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PROFILO_ARIANNA_SUCCESS:
            return {
                ...state,
                profiloArianna: action.payload
            }
        case GET_SCREENING_RESULT_SUCCESS:
            return {
                ...state,
                screeningResult: action.payload
            }
        case GET_ADHESION_STATUS_SUCCESS:
            return {
                ...state,
                adhesionStatus: action.payload
            }
        case GET_INVITE_REMINDER_SUCCESS:
            return {
                ...state,
                inviteReminder: action.payload
            }
        case POST_APPOINTMENT_CONFIRM_SUCCESS:
            return {
                ...state,
                appointmentConfirm: action.payload
            }
        case RESET_SCREENING_STATE:
            return initialState

        case 'persist/REHYDRATE':
            return state;

        default:
            return state;
    }
}